/* eslint-disable */
export default {
  inAMeeting: 'En réunion',
  onMyWay: 'En route',
  callMeBackIn: 'Rappelez-moi dans...',
  willCallYouBackIn: 'Vous rappellera dans...',
  hour: 'heure',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
